var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.243 16.182c1.025-1.026.194-3.519-1.856-5.569S8.843 7.732 7.818 8.757s-.194 3.518 1.856 5.568 4.544 2.882 5.569 1.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.4 9.7.888 21.121a1.5 1.5 0 0 0 1.991 1.991L14.3 16.605M12.857.75c.211 1.89.03 3.803-.531 5.62m4.243-4.242-.53 2.651m7.211 6.364a13.8 13.8 0 0 0-5.62.531m4.242-4.243-2.651.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.083 5.154a.375.375 0 0 1 0-.75m0 .75a.375.375 0 1 0 0-.75m7.425 3.933a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m4.242-3.493a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m0 11.356a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgConfetti;